var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('topWell',{attrs:{"showNews":true},on:{"checkTab":_vm.checkTab}}),_c('business'),_c('nextNews'),_c('operational'),_c('investment'),_c('policiesRegulations'),_c('Formula'),_c('workOfParty'),_c('partner'),_c('bottomNav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }